// extracted by mini-css-extract-plugin
module.exports = {"listContact":"Contact_listContact_TVWmO","brandList":"Contact_brandList_ROHlq","contactList":"Contact_contactList_2Cln2"};